import React from 'react';
import { translate } from 'react-i18next';
import classNames from 'classnames';
import { Text } from 'wix-style-react';
import s from '../InfoItem.scss';

const SocialLinks = ({ t, expertDetails, onLinkClicked }) =>
  expertDetails ? (
    <div>
      {Object.keys(expertDetails.socials)
        .filter(socialName => expertDetails.socials[socialName] !== '')
        .map((socialName, index) => (
          <div
            className={s.infoItem}
            key={index}
            data-hook="expert-card-linked-account-item"
          >
            <div className={classNames(s.infoIcon, s[`icon-${socialName}`])} />
            <div className={s.infoText}>
              <a
                href={expertDetails.socials[socialName]}
                onClick={() => onLinkClicked(socialName)}
                data-hook="expert-card-linked-account-item-link"
                target="_blank"
                rel="noreferrer"
              >
                <Text
                  size="small"
                  secondary={false}
                  light={false}
                  tagName="span"
                  weight="thin"
                >
                  {t('client-expertview-card-' + socialName.toLowerCase())}
                </Text>
              </a>
            </div>
          </div>
        ))}
    </div>
  ) : (
    <div />
  );

export default translate()(SocialLinks);
